<script lang="ts" setup>
import CachedImage from "@/components/tools/CachedImage.vue";

defineProps({
  avatar: {
    type: String,
    default: null,
  },
  fallback: {
    type: String,
    default: null,
  },
});
</script>
<template>
  <div class="avatar">
    <cached-image
      v-if="avatar"
      :src="avatar"
      :viewer="false"
      :full-screen-button="false"
    />
    <span class="avatar-fallback" v-else-if="fallback">{{ fallback }}</span>
  </div>
</template>

<style>
.avatar {
  --_size: var(--avatar-size, 1.5rem);
  width: var(--_size);
  height: var(--_size);
  min-width: var(--_size);
  min-height: var(--_size);
  border-radius: 50%;
  background-color: var(
    --ion-background-color-avatar,
    --ion-color-secondary-shade
  );
  position: relative;
  display: inline-block;
}
.avatar span img,
.avatar span,
.avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
.avatar-fallback {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: calc(var(--_size) / 2.5);
  line-height: 1;
}
</style>
